import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

export default () => {
  const roles = useSelector((state) => state.user.roles);
  const [role, setRole] = useState(false);

  useEffect(() => {
    const hasRole = roles.includes("82D5A2C4-40C3-45C8-B83D-0B98B0716F06");
    if (hasRole) {
      setRole(true);
    }
  });

  return role;
};
